var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5138 10.5133C13.0692 9.98821 13.3812 9.27597 13.3812 8.53341C13.3812 7.79079 13.0692 7.0786 12.5138 6.5535C11.9584 6.0284 11.2051 5.7334 10.4197 5.7334C9.63425 5.7334 8.88092 6.0284 8.3255 6.5535C7.77014 7.0786 7.45812 7.79079 7.45812 8.53341C7.45812 9.27597 7.77014 9.98821 8.3255 10.5133C8.88092 11.0384 9.63425 11.3334 10.4197 11.3334C11.2051 11.3334 11.9584 11.0384 12.5138 10.5133Z",
    stroke: "#878787",
    strokeWidth: 1.89383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.53334C2.25767 4.7468 6.00007 2 10.4197 2C14.8402 2 18.5817 4.7468 19.8393 8.53334C18.5817 12.3198 14.8402 15.0666 10.4197 15.0666C6.00007 15.0666 2.25767 12.3198 1 8.53334Z",
    stroke: "#878787",
    strokeWidth: 1.89383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4641 0.143272C19.6658 0.334301 19.6658 0.643761 19.4641 0.834791L1.88257 17.4569C1.83454 17.5023 1.77753 17.5383 1.71479 17.5628C1.65206 17.5874 1.58482 17.6 1.51692 17.6C1.44902 17.6 1.38178 17.5873 1.31906 17.5627C1.25633 17.5382 1.19934 17.5021 1.15134 17.4567C1.10334 17.4113 1.06527 17.3574 1.03931 17.2981C1.01334 17.2388 0.999982 17.1752 1 17.111C1.00002 17.0468 1.01341 16.9833 1.03941 16.924C1.06541 16.8647 1.10351 16.8108 1.15154 16.7654L18.7327 0.143272C18.9344 -0.0477573 19.2621 -0.0477573 19.4641 0.143272Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeHide);
export default __webpack_public_path__ + "static/media/icon-eye-hide.18ebf5aca8e6b11ea3f8697c7a04ae9f.svg";
export { ForwardRef as ReactComponent };